/**
 * Mapeia hostname de domínio personalizado → slug do cartão.
 * Inclui apex e www para o mesmo cliente.
 */
export const domainMap: Record<string, string> = {
    'drdaniloblanco.com.br': 'drdaniloblanco',
    'www.drdaniloblanco.com.br': 'drdaniloblanco',
};

export function getSlugFromHostname(hostname: string = window.location.hostname): string | null {
    const normalized = hostname.toLowerCase().replace(/^www\./, '');
    return (
        domainMap[hostname.toLowerCase()] ??
        domainMap[normalized] ??
        domainMap[`www.${normalized}`] ??
        null
    );
}
